import React from 'react';
import {Box, Checkbox, Stack, Tooltip} from "@mui/material";
import TextFieldObjectWithEntitySupplierList from "./TextFieldObjectWithEntitySupplierList";
import {materialCutDefault} from "../../../../data/MaterialCutDefault";
import MaterialTextFieldObjectWithEntityListCutDefault from "./MaterialTextFieldObjectWithEntityListCutDefault";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextFieldSimple from "../../textfield/TextFieldSimple";
import CircularProgress from "@mui/material/CircularProgress";
import TextFieldValidation from "../../table/customer-detales/TextFieldValidation";
import MenuItem from "@mui/material/MenuItem";

const SettingsCuttingModule = ({
                                   material,
                                   setSupplierId,
                                   supplierId,
                                   supplierList,
                                   cutDefault,
                                   setCutDefault,
                                   drawEdge,
                                   setDrawEdge,
                                   cutWeight,
                                   setCutWeight,
                                   limitNumberTurns,
                                   setLimitNumberTurns,
                                   rotatePartInsideStrip,
                                   setRotatePartInsideStrip,
                                   alternativeServer,
                                   setAlternativeServer,
                                   trimmingLeft,
                                   setTrimmingLeft,
                                   trimmingRight,
                                   setTrimmingRight,
                                   trimmingBottom,
                                   setTrimmingBottom,
                                   trimmingTop,
                                   setTrimmingTop,
                                   setMinBalanceUpToWholeSheet,
                                   minBalanceUpToWholeSheet,
                                   minACutOff,
                                   setMinACutOff,
                                   minBCutOff,
                                   setMinBCutOff,
                                   isLoading,
                                   percentCutOff,
                                   setPercentCutOff,
                                   percentWaste,
                                   setPercentWaste,
                                   count,
                                   setCount
                               }) => {
    const handleCheckbox = (checkbox) => {
        switch (checkbox) {
            case 'drawEdge':
                setDrawEdge(!drawEdge);
                break;
            case 'rotatePartInsideStrip':
                setRotatePartInsideStrip(!rotatePartInsideStrip);
                break;
            default:
                break;
        }
    }

    return (
        isLoading ?
            <Box sx={{
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <CircularProgress disableShrink/>
            </Box> : <div>
                <Stack
                    sx={{
                        maxWidth: "300px",
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            gap: '0.5rem',
                            p: '0.5rem',
                            flexWrap: 'wrap',
                            flexDirection: 'column',
                        }}
                    >
                        <TextFieldValidation
                            select
                            label="Поставщик"
                            value={supplierId}
                            setCurrValues={setSupplierId}
                            width={"370px"}
                        >
                            {supplierList?.map((option) => (
                                <MenuItem key={option.id} value={option.id}>
                                    {option.name}
                                </MenuItem>
                            ))}
                        </TextFieldValidation>
                        <MaterialTextFieldObjectWithEntityListCutDefault
                            label="Кроить по умолчанию"
                            value={cutDefault}
                            setValue={setCutDefault}
                            field={'cutDefault'}
                            entityList={materialCutDefault}
                        />
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            '& > *': {
                                marginRight: '10px',
                            }
                        }}>
                            <TextFieldSimple
                                label="Отсуп слева"
                                value={trimmingLeft}
                                setValue={setTrimmingLeft}
                                field={'trimmingLeft'}
                                width={"180px"}
                            />
                            <TextFieldSimple
                                label="Отсуп справа"
                                value={trimmingRight}
                                setValue={setTrimmingRight}
                                field={'trimmingRight'}
                                width={"180px"}
                            />
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            '& > *': {
                                marginRight: '10px',
                            }
                        }}>
                            <TextFieldSimple
                                label="Отсуп сверху"
                                value={trimmingTop}
                                setValue={setTrimmingTop}
                                field={'trimmingTop'}
                                width={"180px"}
                            />
                            <TextFieldSimple
                                label="Отсуп снизу"
                                value={trimmingBottom}
                                setValue={setTrimmingBottom}
                                field={'trimmingBottom'}
                                width={"180px"}
                            />
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            '& > *': {
                                marginRight: '10px',
                            }
                        }}>
                            <TextFieldSimple
                                label="Ширина реза"
                                value={cutWeight}
                                setValue={setCutWeight}
                                field={'cutWeight'}
                                width={"180px"}
                            />
                            <TextFieldSimple
                                label="Макс кол. поворотов"
                                value={limitNumberTurns}
                                setValue={setLimitNumberTurns}
                                field={'limitNumberTurns'}
                                width={"180px"}
                            />
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            '& > *': {
                                marginRight: '10px',
                            }
                        }}>
                            <TextFieldSimple
                                label="Мин. ширина обрезка"
                                value={minACutOff}
                                setValue={setMinACutOff}
                                field={'minACutOff'}
                                width={"180px"}
                            />
                            <TextFieldSimple
                                label="Мин. высота обрезка"
                                value={minBCutOff}
                                setValue={setMinBCutOff}
                                field={'minBCutOff'}
                                width={"180px"}
                            />
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            '& > *': {
                                marginRight: '10px',
                            }
                        }}>
                            <TextFieldSimple
                                label="макс. % обрезков"
                                value={percentCutOff}
                                setValue={setPercentCutOff}
                                field={'percentCutOff'}
                                width={"180px"}
                            />
                            <TextFieldSimple
                                label="макс. % отходов"
                                value={percentWaste}
                                setValue={setPercentWaste}
                                field={'percentCutOff'}
                                width={"180px"}
                            />
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            '& > *': {
                                marginRight: '10px',
                            }
                        }}>
                            <TextFieldSimple
                                label="Максимальное количество листов в пакете"
                                value={count}
                                setValue={setCount}
                                field={'count'}
                                width={"370px"}
                            />
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'flex-start',
                            '& > *': {
                                marginRight: '10px',
                            }
                        }}>
                            <TextFieldSimple
                                label="Минимальный остаток до целого листа"
                                value={minBalanceUpToWholeSheet}
                                setValue={setMinBalanceUpToWholeSheet}
                                field={'minBalanceUpToWholeSheet'}
                                width={"370px"}
                            />
                        </Box>
                        <Box sx={{width: '400px', marginRight: '20px'}}>
                            <Tooltip title={'Отображать кромки на карте раскроя'}>
                                <FormControlLabel
                                    control={<Checkbox
                                        onChange={() => handleCheckbox('drawEdge')}
                                        checked={drawEdge}
                                    />}
                                    label="Отображать кромки"
                                />
                            </Tooltip>
                        </Box>
                        <Box sx={{width: '400px', marginRight: '20px'}}>
                            <FormControlLabel
                                control={<Checkbox
                                    onChange={(e, checked) => setAlternativeServer(checked)}
                                    checked={Boolean(alternativeServer)}
                                />}
                                label="Альтернативный раскрой"
                            />
                        </Box>
                        <Tooltip title={'Запрещает или разрешает поворот в полосе'}>
                            <FormControlLabel
                                control={<Checkbox
                                    onChange={() => handleCheckbox('rotatePartInsideStrip')}
                                    checked={rotatePartInsideStrip}
                                />}
                                label="Поворот детали в полосе"
                            />
                        </Tooltip>
                    </Box>
                </Stack>
            </div>
    );
};

export default SettingsCuttingModule;